import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const MUICustomToggle = ({
    value,
    onChange,
    leftText = "Yes",
    rightText = "No",
    disabled = false,
    width = 150,
    height = 36,
    sx = {},
}) => {
    const handleChange = (_, newValue) => {
        if (newValue !== null) {
            onChange(newValue);
        }
    };

    return (
        <ToggleButtonGroup
            exclusive
            value={value}
            onChange={handleChange}
            disabled={disabled}
            sx={{
                width,
                height,
                borderRadius: "30px",
                overflow: "hidden",
                ...sx,
            }}
        >
            <ToggleButton
                value={true}
                sx={{
                    flex: 1,
                    border: "none",
                    textTransform: "none",
                    fontWeight: value === true ? 700 : 600,
                    "&.Mui-selected": {
                        background: disabled
                            ? "#cccccc"
                            : "linear-gradient(to left, #facf39, #fbdb6b)",
                        color: "#000",
                    },
                }}
            >
                {leftText}
            </ToggleButton>

            <ToggleButton
                value={false}
                sx={{
                    flex: 1,
                    border: "none",
                    textTransform: "none",
                    fontWeight: value === false ? 700 : 600,
                    "&.Mui-selected": {
                        background: disabled
                            ? "#cccccc"
                            : "linear-gradient(to left, #facf39, #fbdb6b)",
                        color: "#000",
                    },
                }}
            >
                {rightText}
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

export default MUICustomToggle;